"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var DateUtil = require("@immanens-com/pv5js/common/utils/date-util");
var UrlUtil = require("@immanens-com/pv5js/common/utils/url-util");

var debug = require("debug")("views:CalendarView");
var template = require("../templates/calendar-template.html");

var ArticleQueryModel = require("../../search/models/article-query-model");

/**
 * CalendarView: affichaeg des numéros du mois courant
 * Trigger
 */
module.exports = Backbone.View.extend({

    documentModel: null,
    userModel: null,
    template: _.template(template), // compile template
    className: "calendar-view",
    searchAccess: "public",
    queryModel: null,
    documentQueryModel: null,
    articleQueryModel: null,
    from: null,
    index: null,
    fetching: false,
    baseRoute:"/journal",

    events: {
        "click .search-all-issues": "onSearchAllIssuesClicked",
        "click .search-current-date": "onSearchCurrentDateClicked",
        "click .previous-month": "onPreviousMonthClicked",
        "click .previous-year": "onPreviousYearClicked",
        "click .next-month": "onNextMonthClicked",
        "click .next-year": "onNextYearClicked",
        "click a.doc-line": "onDocClicked"
    },

    initialize: function (options) {
        var T = this;
        _.extend(T, options);

        T.listenToOnce(T.documentModel, "sync", T.render);

        // requête pour récupérer tous les document du mois
        T.documentQueryModel = new ArticleQueryModel({
            useAgg: false,
            highlight: false,
            access: T.searchAccess,
            publicationId: T.documentModel.get("publicationId"),
            sort: "date-asc",
            pageSize: 50,

        }, {
                pv5api: T.app.pv5api,
                minPublishedDate: T.app.minPublishedDate,
                maxPublishedDate: T.app.maxPublishedDate
            });

        T.listenTo(T.documentQueryModel, "change:publishedStart", T.renderDate);

        // requête pour avoir le nombre de résultats pour chaque documents
        // todo : recopier la recherche depuis le from
        T.articleQueryModel = new ArticleQueryModel({
            useAgg: true,
            aggSizes: {
                persons: 0,
                organizations: 0,
                geolocs: 0,
                events: 0,
                types: 0,
                periodicities: 0,
                publications: 0,
                wikitags: 0,
                themes: 0,
                documents: 50
            },
            highlight: false,
            access: T.searchAccess,
            publicationId: T.documentModel.get("publicationId"),
            sort: "date-asc",
            pageSize: 0,
            allTerms: T.queryModel.get("allTerms"),
            phrase: T.queryModel.get("phrase"),
            someTerms: T.queryModel.get("someTerms"),
            exact: T.queryModel.get("exact")
        }, {
                pv5api: T.app.pv5api,
                minPublishedDate: T.app.minPublishedDate,
                maxPublishedDate: T.app.maxPublishedDate
            });

        T.render();
    },

    render: function () {
        var T = this,
            context = {
                results: [],
                isPremium: T.userModel.isPremium()
            };

        if (T.documentModel.fetched) {
            debug("render");
            context.readerUrl = function (result) {
                return T.readerUrl(result);
            };
            context.documentId = T.documentModel.get("id");
            if (T.documentQueryModel.get("results").length) {
                // on combine les résultats de la requête first (sur les documents) et second (sur les articles)
                var agg = T.articleQueryModel.get("aggregations").findWhere({ name: "documents" });
                if (agg) {
                    _.each(agg.get("agg").buckets, function (bucket) {
                        var result = T.documentQueryModel.get("results").findWhere({ id: bucket.key });
                        if (result) {
                            result.set("nbHits", bucket.doc_count);
                        }
                    });
                }
                context.results = T.documentQueryModel.get("results").toJSON();
            }

            T.$el.html(T.template(context));
            T.gotoCurrent();
            T.renderDate();
        }
    },

    renderDate: function () {
        var T = this,
            date_obj = DateUtil.dateFactory(T.documentQueryModel.get("publishedStart") || T.documentModel.get("published"));
        if (date_obj) {
            T.$(".month").text(STR["month_" + (date_obj.getUTCMonth() + 1)]);
            T.$(".year").text(date_obj.getUTCFullYear());
        }
    },

    gotoCurrent: function () {
        var T = this,
            $body = T.$(".calendar-body"),
            $line = T.$(".current");
        if ($line.length) {
            $body.animate({
                scrollTop: $body.scrollTop() + $line.position().top - 50
            },
                500
            );
        }
    },

    onNextMonthClicked: function () {
        var T = this,
            date_obj = DateUtil.dateFactory(T.documentQueryModel.get("publishedStart"));

        if (!T.userModel.isPremium()) {
            T.app.premiumScreen();
            return;
        }

        // on ajoute 1 pour passer au mois suivant
        date_obj.setUTCMonth(date_obj.getUTCMonth() + 1);
        var month = date_obj.getUTCMonth() + 1;
        var year = date_obj.getUTCFullYear();

        T.queryDocumentList(month, year);
    },

    onPreviousMonthClicked: function () {
        var T = this,
            date_obj = DateUtil.dateFactory(T.documentQueryModel.get("publishedStart"));

        if (!T.userModel.isPremium()) {
            T.app.premiumScreen();
            return;
        }

        // on enlève 1 pour passer au mois précédent
        date_obj.setUTCMonth(date_obj.getUTCMonth() - 1);
        var month = date_obj.getUTCMonth() + 1;
        var year = date_obj.getUTCFullYear();

        T.queryDocumentList(month, year);
    },

    onNextYearClicked: function () {
        var T = this;

        if (!T.userModel.isPremium()) {
            T.app.premiumScreen();
            return;
        }

        var date_obj = DateUtil.dateFactory(T.documentQueryModel.get("publishedStart")),
            month = date_obj.getUTCMonth() + 1,
            year = date_obj.getUTCFullYear() + 1;

        T.queryDocumentList(month, year);
    },

    onPreviousYearClicked: function () {
        var T = this;

        if (!T.userModel.isPremium()) {
            T.app.premiumScreen();
            return;
        }

        var date_obj = DateUtil.dateFactory(T.documentQueryModel.get("publishedStart")),
            month = date_obj.getUTCMonth() + 1,
            year = date_obj.getUTCFullYear() - 1;

        T.queryDocumentList(month, year);
    },

    onSearchAllIssuesClicked: function () {
        var T = this,
            search_str = "/search/#sort=score&tfPublications[0]=" + encodeURIComponent(T.documentModel.get("publicationTitle"));

        if (T.userModel.isPremium()) {
            window.location = search_str;
        } else {
            T.app.premiumScreen();
        }
    },

    onSearchCurrentDateClicked: function () {
        var T = this,
            search_str = "/search/#sort=score&publishedStart=" + T.documentModel.get("published");

        if (T.userModel.isPremium()) {
            window.location = search_str;
        } else {
            T.app.premiumScreen();
        }
    },

    onDocClicked: function (e) {
        var T = this,
            $link = $(e.currentTarget),
            route = $link.attr('href');

        e.preventDefault();
        e.stopPropagation();
        
        // on passe par le router pour ne pas sortir du mode plein écran
        if(route){
            route = route.substr(T.baseRoute.length);
            debug(route);
            T.app.router.navigate(
                route, {
                    trigger: true
                }
            );
        }

        return false;
    },

    readerUrl: function (result) {
        var T = this,
            document_id = result.id,
            publication_id = result.publicationId,
            number = result.pageNumber || 1,
            publication_title = result.publicationTitle,
            published = STR.date(result.published);

        var url = T.baseRoute + "/" + UrlUtil.slugify(publication_title) + "/" + UrlUtil.slugify(published) + "/" + publication_id + "/" + document_id + "/" + number;

        if (T.from) {
            url += "?from=" + encodeURIComponent(T.from);
            if(T.index){
                url +="&index="+T.index;
            }
        }
        return url;
    },

    queryDocumentList: function (month, year) {
        var T = this;

        if (!T.userModel.isPremium()) {
            return;
        }

        if (T.fetching) return;
        if (!month) {
            // si rien de précisé on prend la date du document
            var published = T.documentModel.get("published");
            month = parseInt(published.substr(5, 2));
            year = parseInt(published.substr(0, 4));
        }

        var last_day = DateUtil.lastDay(year, month);

        var date_start = year + "-" + month + "-01";
        var date_end = year + "-" + month + "-" + last_day;

        T.documentQueryModel.set({
            publishedStart: date_start,
            publishedEnd: date_end
        });
        T.articleQueryModel.set({
            publishedStart: date_start,
            publishedEnd: date_end
        });

        T.fetching = true;
        T.listenToOnce(T.documentQueryModel, "sync", T.onFirstQuerySync);
        T.documentQueryModel.search();

    },

    onFirstQuerySync: function () {
        var T = this;
        if (T.articleQueryModel.hasTerms()) {
            T.listenToOnce(T.articleQueryModel, "sync", function () {
                T.fetching = false;
                T.render();
            });
            T.articleQueryModel.search();
        }
        else {
            T.fetching = false;
            T.render();
        }
    },

    close: function () {
        var T = this;
        T.documentModel = null;
        T.userModel = null;
        T.documentQueryModel = null;
        T.articleQueryModel = null;
        T.queryModel = null;
        T.stopListening();
        T.undelegateEvents();
    }
});